import { render } from "./accountComponent.vue?vue&type=template&id=5254f550&scoped=true"
import script from "./accountComponent.vue?vue&type=script&lang=js"
export * from "./accountComponent.vue?vue&type=script&lang=js"

import "./accountComponent.vue?vue&type=style&index=0&id=5254f550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5254f550"]])

export default __exports__